import { createFileRoute } from "@tanstack/react-router";
import { CertificacaoLP } from "@/components/certificacao/CertificacaoLP";
import { CERT_META } from "@/lib/certificacao/config";
import { CERT_DATA } from "@/lib/certificacao/data";
import { QUADRIL_OFERTA } from "@/lib/certificacao/oferta";

const m = CERT_META.quadril;
const SITE = "https://fisioemortopedia.com.br";
const URL = `${SITE}${m.path}`;
const SHARE_IMG = CERT_DATA.quadril.heroBg?.startsWith("https://") ? CERT_DATA.quadril.heroBg : undefined;

export const Route = createFileRoute("/certificacao-quadril")({
  head: () => ({
    meta: [
      { title: m.seoTitle },
      { name: "description", content: m.seoDescription },
      { property: "og:title", content: m.seoTitle },
      { property: "og:description", content: m.seoDescription },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { property: "og:site_name", content: "Fisio em Ortopedia" },
      ...(SHARE_IMG ? [{ property: "og:image", content: SHARE_IMG }] : []),
      { property: "og:locale", content: "pt_BR" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: m.seoTitle },
      { name: "twitter:description", content: m.seoDescription },
      ...(SHARE_IMG ? [{ name: "twitter:image", content: SHARE_IMG }] : []),
    ],
    links: [
      { rel: "canonical", href: URL },
      // LCP: fundo do topo baixado com prioridade máxima.
      ...(CERT_DATA.quadril.heroBg
        ? [
            {
              rel: "preload",
              as: "image",
              href: CERT_DATA.quadril.heroBg,
              fetchPriority: "high" as const,
            },
          ]
        : []),
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Course",
          name: m.nome,
          description: m.seoDescription,
          url: URL,
          inLanguage: "pt-BR",
          educationalLevel: "Profissional",
          teaches: "Avaliação e reabilitação do quadril",
          provider: {
            "@type": "Organization",
            name: "Fisio em Ortopedia",
            url: SITE,
          },
          offers: {
            "@type": "Offer",
            price: `${QUADRIL_OFERTA.aVistaValor.replace(/\D/g, "")}.00`,
            priceCurrency: "BRL",
            url: URL,
            availability: "https://schema.org/InStock",
          },
          hasCourseInstance: {
            "@type": "CourseInstance",
            courseMode: "online",
            courseWorkload: "PT60H",
          },
        }),
      },
    ],
  }),
  component: CertQuadrilRoute,
});

function CertQuadrilRoute() {
  return <CertificacaoLP slug="quadril" mode="venda" embeddedCheckout />;
}
